import { makeStyles } from '@material-ui/core/styles';
import { secondaryButtonStyle } from '../../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../../theme';
import { minorResultSharedStyles } from '../Results.styles';

const { colors, fonts, fontSize, radius, breakpoints } = redesignTheme;

export const useIASynthesisStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 800,
    margin: '0 auto',
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    width: '100%',
    padding: 24,
    border: '1px solid rgba(122, 101, 85, 0.24)',
    borderRadius: radius.sm,
    backgroundColor: colors.primaryDark,
    boxSizing: 'border-box',
  },
  panelLoading: {
    height: 217,
    minHeight: 217,
    gap: 16,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: 8,
    borderRadius: radius.sm,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  badgeIcon: {
    width: 16,
    height: 16,
    color: colors.white,
  },
  badgeText: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.white,
    lineHeight: 'normal',
  },
  copyBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    textAlign: 'center',
    color: colors.white,
  },
  title: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.xl,
    lineHeight: 'normal',
    color: colors.white,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.lg,
    },
  },
  description: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: '20px',
    color: colors.white,
    whiteSpace: 'normal',
    maxWidth: 640,
  },
  ctaButton: {
    ...secondaryButtonStyle,
  },
  ctaIcon: {
    ...minorResultSharedStyles.icon16,
  },
  loadingRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 16,
  },
  loadingSpinner: {
    color: colors.white,
  },
  loadingText: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.intro,
    lineHeight: '20px',
    color: '#fafafa',
  },
  resultPanel: {
    width: '100%',
    border: '1px solid rgba(122, 101, 85, 0.24)',
    borderRadius: radius.sm,
    overflow: 'hidden',
    backgroundColor: colors.white,
  },
  resultHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 92,
    padding: '20px 24px',
    backgroundColor: colors.primaryDark,
  },
  resultHeaderText: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    lineHeight: 1.3,
    color: colors.white,
    textAlign: 'center',
  },
  resultBody: {
    position: 'relative',
    padding: 20,
    textAlign: 'center',
  },
  resultContent: {
    color: colors.overlay,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: '20px',
    textAlign: 'left',
    '& p, & h3': {
      margin: 0,
    },
  },
  resultFade: {
    ...minorResultSharedStyles.fadeOverlay,
  },
  expandButton: {
    position: 'relative',
    zIndex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    height: 40,
    marginTop: -20,
    padding: '0 24px',
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    color: colors.primaryDark,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    letterSpacing: 0.28,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: colors.hoverSurface,
    },
    '&:active': {
      backgroundColor: colors.surface,
      transform: 'scale(0.98)',
    },
  },
  collapseButton: {
    display: 'inline-flex',
    marginTop: 16,
    padding: '8px 0',
    border: 0,
    background: 'transparent',
    color: colors.primaryDark,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    textDecoration: 'underline',
  },
  errorText: {
    margin: '0 0 16px',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: '20px',
    color: colors.white,
    textAlign: 'center',
    maxWidth: 640,
  },
  retryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    padding: '0 24px',
    border: `1px solid ${colors.white}`,
    borderRadius: radius.sm,
    backgroundColor: 'transparent',
    color: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
  },
}));
